module.exports = require('./_hide');


/*****************
 ** WEBPACK FOOTER
 ** ./~/._core-js@2.4.1@core-js/library/modules/_redefine.js
 ** module id = 168
 ** module chunks = 0 1
 **/